import {activeWasteFlavorsTqo, WasteFlavorPurpose, WasteFlavorStub} from "../rpc/webrpc-client.gen.ts";
import {useSelf} from "../agent/useSelf.ts";
import {useMemo} from "react";
import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";
import {useInfallibleQuery} from "../util/useInfallibleQuery.tsx";
import {useMothership} from "../tq/tqx.tsx";

export function useShowableWasteFlavors(): InfallibleUseResult<WasteFlavorStub[]> {
    const {data: self} = useSelf();
    let purpose: WasteFlavorPurpose | undefined;
    if (self?.canDrive) {
        purpose = WasteFlavorPurpose.enum.SHOW_TO_DRIVER;
    } else if (self?.admitterFor) {
        purpose = WasteFlavorPurpose.enum.SHOW_TO_INTAKER;
    } else if (self?.inspectorFor) {
        purpose = WasteFlavorPurpose.enum.SHOW_TO_INSPECTOR;
    } else if (self?.supervisorFor) {
        purpose = WasteFlavorPurpose.enum.SHOW_TO_SUPERVISOR;
    }
    return useActiveWasteFlavors(purpose ? {purpose} : undefined);
}

export function useActiveWasteFlavors(args ?: {purpose: WasteFlavorPurpose}): InfallibleUseResult<WasteFlavorStub[]> {
    const mama = useMothership();
    const tqrv = useInfallibleQuery(activeWasteFlavorsTqo(mama, args ? {purpose: args.purpose} : undefined));
    if (tqrv.isPending) {
        return pendingUseResult;
    }
    const flavorStubs = tqrv.data;
    return successUseResult(flavorStubs);
}

export function useShowableFlavorsById(): InfallibleUseResult<Map<string, WasteFlavorStub>> {
    const tqrv = useShowableWasteFlavors();
    const rv = useMemo(() => {
        if (!tqrv.isSuccess) {
            return pendingUseResult;
        } else {
            const rv = new Map<string, WasteFlavorStub>();
            tqrv.data.forEach(flavor => rv.set(flavor.id, flavor));
            return successUseResult(rv);
        }
    }, [tqrv.data, tqrv.isSuccess]);

    return rv;
}

export function useBirthableWasteFlavors(): InfallibleUseResult<WasteFlavorStub[]> {
    return useActiveWasteFlavors({purpose: WasteFlavorPurpose.enum.BIRTH})
}

export function useBirthableWasteFlavorsByCode(): InfallibleUseResult<Map<string, WasteFlavorStub>> {
    const tqrv = useBirthableWasteFlavors();
    const rv = useMemo(() => {
        if (!tqrv.isSuccess) {
            return pendingUseResult;
        } else {
            const rv = new Map<string, WasteFlavorStub>();
            tqrv.data.forEach(flavor => rv.set(flavor.code, flavor));
            return successUseResult(rv);
        }
    }, [tqrv.data, tqrv.isSuccess]);
    return rv;
}

export function useShortformWasteFlavors(): InfallibleUseResult<WasteFlavorStub[]> {
    return useActiveWasteFlavors({purpose: WasteFlavorPurpose.enum.SHORT_FORM});
}
